import React from 'react';
import DOMPurify from 'dompurify';
import {Header, Segment, Loader} from 'semantic-ui-react';
import _ from 'lodash';
import ApiActions from 'go/actions/api';
import {connect} from 'react-redux';
import {
  TEMPLATE_GET_SUCCESS,
  TEMPLATE_GET_REQUEST,
  TEMPLATE_GET_FAILURE,
} from 'common/types';
import Error from 'app-ui-componentlibrary/dist/go/components/common/error';
import {buildParamString} from 'common/utils';

export class TemplateRenderer extends React.Component {
  constructor() {
    super();
    this.state = {
      templateContent: [],
      loading: true,
      error: false,
    };
  }

  UNSAFE_componentWillMount() {
    if (this.allParamsDefined()) {
      this.loadTemplates();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !_.isEqual(this.props.params, prevProps.params) &&
      _.isEmpty(this.state.templateContent)
    ) {
      this.loadTemplates();
    }
  }

  allParamsDefined = () => {
    const {params} = this.props;
    return _.isEmpty(_.filter(params, (param) => param.value === undefined));
  };

  loadTemplates = () => {
    let {token, templateNames, params, dontRender} = this.props;
    let paramString = buildParamString(templateNames, params);
    !dontRender &&
      this.props.getTemplate(token, paramString).then((res) => {
        if (res.type === TEMPLATE_GET_SUCCESS) {
          this.setState({
            templateContent: res.payload.templates,
            loading: false,
            error: false,
          });
        } else {
          this.setState({
            loading: false,
            error: true,
          });
        }
      });
  };

  sanitizeHtml = (html) => {
    return DOMPurify.sanitize(html);
  };

  render() {
    let {title, mergedTitles, dontRender, displayHeading, displayIfs} = this.props;
    let {loading, error} = this.state;

    mergedTitles = mergedTitles ? mergedTitles : [];
    if (dontRender) return null;
    if (loading) return <Loader active inline="centered" content="Loading" />;
    if (error) return <Error />;

    return _.map(this.state.templateContent, (html, i) => {
      const displayIf =
        !displayIfs || displayIfs[i] === true || _.get(this.props, displayIfs[i]);
      let templateContent = (
        <div dangerouslySetInnerHTML={{__html: this.sanitizeHtml(html)}} />
      );
      return displayIf ? (
        <Segment key={'template-segment-' + i}>
          {displayHeading && <Header as="h2">{mergedTitles[i] || title}</Header>}
          <p>{this.props.guidance}</p>
          <div id={mergedTitles[i] || title}>{templateContent}</div>
        </Segment>
      ) : null;
    });
  }
}

export const mapStateToProps = (state, ownProps) => {
  const props = {};
  const currParams = _.cloneDeep(ownProps.params);
  props.params = _.map(currParams, (entry) => {
    entry.value = _.get(state.dynamicComponent, entry.dataPath);
    return entry;
  });
  props.token = state.auth.token;
  return props;
};

export const mapDispatchToProps = (dispatch) => ({
  getTemplate: (token, paramString) => {
    let action = ApiActions.template.getTemplate(token, paramString);
    const res = dispatch(action);
    return res;
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplateRenderer);
